/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TextIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA30lEQVR4nO2VPQpCMRCEFbyE4F1eoWBjdvc17oBnUPE0/rR23sK/RtCD6CGU+Kz0RXbVRnEg1UdmJmRJKpVvUJZltXf2V4mxC4JtGQyiB2LsX3bP816DBGcSPZWweoqZxdxtR5MgWN4zom4rxcwiwuhqwjp+YKLDFDMrsM4KE/Q9zCxibKJJh7XpYeVtBdvi0t5crOtEW11/IiAIVqYTxaMXjbDxMLMox+DWauph9gDB9GqSY+Bh9gD+T9BPT1AQnaSm5BlzBGCVemeeMbOIcYwm8VPxMEeAzomx8LLf0wU5qioqdQL/4AAAAABJRU5ErkJggg==)
 */
export const TextIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M10.99 3.16A1 1 0 1 0 9 2.84L8.15 8H4a1 1 0 0 0 0 2h3.82l-.67 4H3a1 1 0 1 0 0 2h3.82l-.8 4.84a1 1 0 0 0 1.97.32L8.85 16h4.97l-.8 4.84a1 1 0 0 0 1.97.32l.86-5.16H20a1 1 0 1 0 0-2h-3.82l.67-4H21a1 1 0 1 0 0-2h-3.82l.8-4.84a1 1 0 1 0-1.97-.32L15.15 8h-4.97l.8-4.84ZM14.15 14l.67-4H9.85l-.67 4h4.97Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
